import UnderConstruction from "../Components/UnderConstruction";

export default function Terms() {
  return <UnderConstruction />;
}
